import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { Card, CardBody, CardFooter, CardHeader } from "../card/card";

export default function ConfirmationDlg({
  title,
  open,
  onClose,
  onSubmit,
  children,
  disableClose = false,
  dialogClassName = "",
  size = "md",
  type = "confirmation",
  btnSubmitText,
  btnCancelText,
  hideCancelBtn = false,
}) {
  return (
    <Modal
      show={open}
      size={!dialogClassName ? size : ""}
      dialogClassName={dialogClassName}
      onHide={onClose}
      onBackdropClick={disableClose ? onSubmit : onClose}
      centered
      backdrop={disableClose ? "static" : true}
    >
      <Modal.Body className="p-0">
        <Card>
          <CardHeader className="p-3">
            {title}
            {disableClose ? null : (
              <button
                className="btn"
                style={{
                  position: "absolute",
                  fontSize: 8,
                  textTransform: "uppercase",
                  right: 0,
                  top: "0",
                  bottom: "0",
                  marginTop: "auto",
                  marginBottom: "auto",
                  textDecoration: "underline",
                  minWidth: "30px",
                }}
                onClick={onClose}
              >
                CLOSE
              </button>
            )}
          </CardHeader>
          <CardBody>{children}</CardBody>
          <CardFooter style={{ zIndex: 1 }}>
            <div
              style={{
                textAlign: "center",
                display: type == "alert" ? "none" : "flex",
                justifyContent: "flex-end",
                padding: "10px 0",
              }}
            >
              <button className="btn btn-outline-theme me-2" onClick={onSubmit}>
                {btnSubmitText
                  ? btnSubmitText
                  : type == "confirmation"
                  ? "Yes"
                  : "Submit"}
              </button>
              <button
                className="btn btn-outline-danger"
                style={{
                  display: hideCancelBtn ? "none" : "inherit",
                }}
                onClick={onClose}
              >
                {btnCancelText
                  ? btnCancelText
                  : type == "confirmation"
                  ? "No"
                  : "Cancel"}
              </button>
            </div>
          </CardFooter>
        </Card>
      </Modal.Body>
    </Modal>
  );
}
